module.exports = __webpack_public_path__ + "static/media/personImportTemporary.a0ce2bda.xlsx";